export default async function clearLeadNotifications({ state }) {
  state.set(['apartmentLocator', 'leadsUpdated'], {});
  state.commit();
}
